import BaseEntity from '@/editor/entities/BaseEntity';
import RegionModel2d from './2d/regionModel';
import { cloneDeep } from 'lodash-es';
import { EEntityType } from '../types';
import { RegionData } from '../data/region/Region';
import RegionModel3d from './3d/regionModel';
import { equalOutlines } from '../math/utils';
import { getPathFromEdges } from '../utils/edge';
import { dispersePath } from '../utils/shape';

class RegionEntity extends BaseEntity<EEntityType.Region> {
  private _regionData: RegionData;

  protected override _model2d: RegionModel2d;
  protected override _model3d: RegionModel3d;

  constructor(regionData: RegionData) {
    super({
      type: EEntityType.Region,
      id: regionData.id
    });
    this._regionData = cloneDeep(regionData);

    this._model2d = new RegionModel2d(this._regionData);
    this._model3d = new RegionModel3d(this._regionData);
  }

  override set selected(value: boolean) {
    this._selected = value;
  }

  override get selected() {
    return this._selected;
  }

  get regionData() {
    return this._regionData;
  }

  override update(regionData: RegionData & { forceUpdate?: boolean }) {
    let destroyUpdate = !!regionData.forceUpdate;
    let noDestroyUpdate = false;

    // const newOutline = [
    //   regionData.corePathInfos.map((info) => info.start),
    //   ...regionData.coreHoleInfos.map((holes) => holes.map((hole) => hole.start))
    // ];
    // const oldOutline = [
    //   this._regionData.corePathInfos.map((info) => info.start),
    //   ...this._regionData.coreHoleInfos.map((holes) => holes.map((hole) => hole.start))
    // ];
    const newOutline = [
      dispersePath(getPathFromEdges(regionData.corePathInfos)),
      ...regionData.coreHoleInfos.map((holes) => dispersePath(getPathFromEdges(holes)))
    ];
    const oldOutline = [
      dispersePath(getPathFromEdges(this._regionData.corePathInfos)),
      ...this._regionData.coreHoleInfos.map((holes) => dispersePath(getPathFromEdges(holes)))
    ];

    if (!equalOutlines(newOutline, oldOutline)) {
      destroyUpdate = true;
    }

    if (regionData.materialInfo.id !== this._regionData.materialInfo.id) {
      noDestroyUpdate = true;
    }

    if (!destroyUpdate && !noDestroyUpdate) return;

    this._regionData = cloneDeep(regionData);
    this._model2d.updateModel(this._regionData);
    this._model3d.createRegionModel(this._regionData);
  }

  changeFloorPlaneStatus(enable: boolean) {
    this._model2d.setFloorPlaneStatus(enable);
  }
}

export default RegionEntity;
